import { Icon } from "armstrong-react";
import classNames from "classnames";
import React from "react";
import { Link } from "react-router";
import _ from "underscore";
import { isServer } from "./../detection";

import "./nav.scss";

export interface INavProps {
  children?: any;
  className?: string;
  isDropdownOnMobile?: boolean;
}

interface INavState {
  ddOpen?: boolean;
  isPhone?: boolean;
  mobileExpanded?: boolean;
}

export class Nav extends React.Component<INavProps, INavState>{
  private checkingSize: boolean;

  constructor(props: INavProps) {
    super(props);
    this.state = { ddOpen: false, isPhone: false, mobileExpanded: false };
  }

  private checkSize() {
    if (!this.checkingSize) {
      this.checkingSize = true;
      const  isPhoneNow = window.innerWidth <= 480;
      if (this.state.isPhone && !isPhoneNow) {
        // Display all images
        this.setState({ isPhone: false, mobileExpanded: true }, () => { this.checkingSize = false });
      }
      else if (!this.state.isPhone && isPhoneNow) {
        // Display just one imageCount
        this.setState({ isPhone: true, mobileExpanded: false }, () => { this.checkingSize = false });
      } else {
        this.checkingSize = false;
      }
    }

  }
  public componentWillMount() {
    if (isServer()) {
      return;
    }
    window.addEventListener("resize", this.checkSize.bind(this));
  }

  public componentDidMount() {
    this.checkSize();
  }

  public componentWillUnmount() {
    if (isServer()) {
      return;
    }
    window.removeEventListener("resize", this.checkSize.bind(this))
  }

  public render() {
    const { className, isDropdownOnMobile, ...rest } = this.props;

    if (!isDropdownOnMobile || (isDropdownOnMobile && !this.state.isPhone)) {
      return (
        <div className={classNames("nav-wrapper", className)}>
          <nav className="nav-list"><ul {...rest}></ul></nav>
        </div>
      );
    } else {
      return (
        <div className="mobile-tab-dropdown">
          <ul {...rest}></ul>
        </div>
      );
    }
  }
}

export interface INavLink extends React.HTMLProps<NavLink> {
  icon?: string;
  to: string;
  title: string;
  onlyActiveOnIndex?: boolean;
  alignRight?: boolean;
  onMouseEnter?: () => void;
  className?: string;
}

// tslint:disable-next-line: max-classes-per-file
export class NavLink extends React.Component<INavLink, {}>{
  public static Icons = Icon.Icomoon;
  public static defaultProps = {
    alignRight: false,
  };
  public render() {
    const  attrs = _.omit(this.props, "icon", "to", "onlyActiveOnIndex", "alignRight", "isDropdownOnMobile");
    return (
      <li className={classNames("nav-link", this.props.alignRight && "nav-link-align-right")} onMouseEnter={() => this.props.onMouseEnter ? this.props.onMouseEnter() : null}>
        <Link to={this.props.to} activeClassName={"active-nav"} onlyActiveOnIndex={this.props.onlyActiveOnIndex}  {...attrs} data-title={this.props.title} className={`nav-link__anchor ${this.props.className || ""}`}>
          {this.props.icon && <Icon icon={this.props.icon} />}
          {this.props.title}
        </Link>
      </li>
    );
  }
}
